import {
    changeEvent,
    clickEvent, customDocumentEvent, customEvent,
    dispatchCustomEvent,
    documentLoadEvent,
    fireChangeEvent
} from "../../../../../webpack/modules/events";
import {initTomSelectQuantity} from "../../../../../webpack/modules-optimized/tomselect";
import {
    hideOptionErrors,
    resetWallpaperCalculator,
    updatePriceElements
} from "../../../../../webpack/modules-optimized/product-page";
import {hideCollapseBySelector} from "../../../../../webpack/modules-optimized/collapse";
import {hideOffcanvas} from "../../../../../webpack/modules-optimized/offcanvas";

documentLoadEvent(function() {
    initTomSelectQuantities();
});

changeEvent('#product-page .options[data-option-type="selectable"] input[name="size"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let previewText = element.dataset.previewText;
    let sizes = container.querySelectorAll(`.size:not([for="${element.id}"])`);
    let size = element.closest('.size') || element.nextElementSibling;
    let confirmButton = offcanvas.querySelector('button.confirm-button');

    unselectSizes(sizes);
    selectSize(size);
    element.checked = true;
    size.classList.add('selected');
    dispatchCustomEvent(
        'productSizeChanged',
        {
            'option': offcanvas,
            'container': container,
            'previewElement': previewElement,
            'previewText': previewText
        }
    );
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    if (confirmButton) confirmButton.classList.remove('disabled');
    if (!size.classList.contains('.wallpaper-calculator')) hideCollapseBySelector('#product-page .wallpaper-calculator .body', false);
    hideOptionErrors(offcanvas);
    updatePriceElements(container);
});

clickEvent('#product-page .options[data-option-type="selectable"] .size-box-container:not(.no-block-open)', false, function(element, event) {
    let target = event.target;
    let tomselect = element.querySelector('.quantity-selector').tomselect;
    let isShow = element.dataset.tsopen || "false";
    isShow = isShow === "true";

    if (target.classList.contains('.ts-wrapper')) return;

    event.preventDefault();
    event.stopPropagation();

    if (!isShow) tomselect.open();
    else tomselect.close();

    element.dataset.tsopen = !isShow;
});

customEvent('show.bs.collapse', '#product-page .wallpaper-calculator .body', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let confirmButton = offcanvas.querySelector('button.confirm-button');
    let wallpaperCalculator = element.closest('.wallpaper-calculator');
    let sizes = document.querySelectorAll(`#product-page .options[data-option-type="selectable"] .size:not(.wallpaper-calculator)`);
    let size = wallpaperCalculator.querySelector('input[name="size"]');

    if (confirmButton && !size.checked && !confirmButton.classList.contains('disabled')) confirmButton.classList.add('disabled');
    unselectSizes(sizes);
    if (!wallpaperCalculator.classList.contains('selected')) wallpaperCalculator.classList.add('selected');

    if (!size.dataset.width && !size.dataset.height) {
        dispatchCustomEvent(
            'productSizeChanged',
            {
                'option': offcanvas,
                'container': container,
                'previewElement': previewElement
            }
        );
    }
});

clickEvent('#product-page .wallpaper-calculator .btn-add-to-cart', false, function(element) {
    let offcanvas = element.closest('.offcanvas');

    hideOffcanvas(offcanvas.id);
});

customDocumentEvent('wallpaperCalculatorResult', function(event) {
    let container = document.querySelector('#product-page');
    let offcanvas = container.querySelector('.offcanvas[data-type="size"]');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let confirmButton = offcanvas.querySelector('button.confirm-button');
    let calculator = offcanvas.querySelector('.wallpaper-calculator');
    if (!calculator) return;
    let size = calculator.querySelector('input[name="size"]');
    let quantity = calculator.querySelector('.quantity');
    let glueComplement = document.querySelector('#product-page input[name="complement"][value="486"]');
    let width = event.detail.width;
    let height = event.detail.height;
    let previewText = event.detail.previewText;
    let rolls = event.detail.rolls;
    let glue = event.detail.glue;

    size.dataset.width = width;
    size.dataset.height = height;
    size.dataset.previewText = previewText;
    size.dataset.quantity = rolls;
    size.checked = true;
    quantity.value = rolls;
    quantity.classList.add('quantity-add-to-cart');
    glueComplement.dataset.quantity = glue;
    glueComplement.checked = true;
    dispatchCustomEvent(
        'productSizeChanged',
        {
            'option': offcanvas,
            'container': container,
            'previewElement': previewElement
        }
    );
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    if (confirmButton) confirmButton.classList.remove('disabled');
});

customDocumentEvent('wallpaperCalculatorReset', function() {
    let container = document.querySelector('#product-page');
    let offcanvas = container.querySelector('.offcanvas[data-type="size"]');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);

    resetWallpaperCalculator(container);
    dispatchCustomEvent(
        'productSizeChanged',
        {
            'option': offcanvas,
            'container': container,
            'previewElement': previewElement
        }
    );
});

function initTomSelectQuantities()
{
    document.querySelectorAll('#product-page .options[data-option-type="selectable"] .select-quantity').forEach(function(quantity) {
        let tomSelect = initTomSelectQuantity(quantity);

        tomSelect.on('dropdown_open', function() {
            tomSelect.updateOption('0', {value: 0, text: 0, disabled: true});
        });

        tomSelect.on('dropdown_close', function() {
            let wrapper = tomSelect.wrapper;
            let size = wrapper.closest('.size');
            let input = document.querySelector(`input[name="size"][id="${size.htmlFor}"]`);
            if (!input) return;

            fireChangeEvent(input);
        });
    });
}

function unselectSizes(sizes)
{
    sizes.forEach(function(size) {
        let container = size.closest('.product-scope');
        let quantitySelector = size.querySelector('.quantity');
        let input = document.querySelector(`input[name="size"][id="${size.htmlFor}"]`) || size.querySelector('input[name="size"]');

        input.checked = false;
        size.classList.remove('selected');
        if (quantitySelector) quantitySelector.classList.remove('quantity-add-to-cart');
        if (quantitySelector && quantitySelector.tomselect){
            quantitySelector.tomselect.updateOption('0', {value: 0, text: 0, disabled: false});
            quantitySelector.tomselect.setValue(0);
            if (!quantitySelector.tomselect.wrapper.classList.contains('disabled')) quantitySelector.tomselect.wrapper.classList.add('disabled');
        }
        if (size.classList.contains('wallpaper-calculator')) resetWallpaperCalculator(container);
    });
}

function selectSize(size)
{
    let quantitySelector = size.querySelector('.quantity');
    let input = document.querySelector(`input[name="size"][id="${size.htmlFor}"]`) || size.querySelector('input[name="size"]');

    input.checked = true;
    size.classList.add('selected');
    if (quantitySelector && !quantitySelector.classList.contains('quantity-add-to-cart')) quantitySelector.classList.add('quantity-add-to-cart');
    if (quantitySelector && quantitySelector.tomselect) {
        if (quantitySelector.tomselect.getValue() === '0') quantitySelector.tomselect.setValue(1);
        quantitySelector.tomselect.wrapper.classList.remove('disabled');
    }
}